import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ThreadInteraction } from "features/Thread/types";
import { SearchMode } from "helpers/api";

export interface AskPaperDrawerSettings {
  isAskPaperDrawerOpen: boolean;
  paperId?: string;
  title?: string;
  fullTextURL?: string;
}

export interface FilterDrawerSettings {
  threadId?: string;
  interaction?: ThreadInteraction;
}

interface SettingState {
  askPaperDrawer: AskPaperDrawerSettings;
  is1024WideScreen: boolean;
  is898WideScreen: boolean;
  is640WideScreen: boolean;
  filterDrawer: FilterDrawerSettings;
  isMobile: boolean | undefined;
  isProToggleOn?: boolean;
  isSidebarOpen: boolean;
  searchMode: SearchMode | undefined;
}

const initialState: SettingState = {
  askPaperDrawer: {
    isAskPaperDrawerOpen: false,
    paperId: undefined,
    title: undefined,
    fullTextURL: undefined,
  },
  is1024WideScreen: false,
  is898WideScreen: false,
  is640WideScreen: false, // Equivalent to sm breakpoint
  filterDrawer: {
    threadId: undefined,
    interaction: undefined,
  },
  isMobile: undefined,
  isProToggleOn: undefined,
  isSidebarOpen: false, // Default closed for mobile, will be initialized based on screen size
  searchMode: undefined,
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setIsMobile(state: SettingState, { payload }: PayloadAction<boolean>) {
      state.isMobile = payload;
    },
    toogleSidebarOpen(state: SettingState) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setSidebarOpen(state: SettingState, { payload }: PayloadAction<boolean>) {
      state.isSidebarOpen = payload;
    },
    set1024WideScreen(
      state: SettingState,
      { payload }: PayloadAction<boolean>
    ) {
      state.is1024WideScreen = payload;
    },
    set898WideScreen(state: SettingState, { payload }: PayloadAction<boolean>) {
      state.is898WideScreen = payload;
    },
    set640WideScreen(state: SettingState, { payload }: PayloadAction<boolean>) {
      state.is640WideScreen = payload;
    },
    setAskPaperDrawerSettings(
      state: SettingState,
      { payload }: PayloadAction<AskPaperDrawerSettings>
    ) {
      state.askPaperDrawer = payload;
    },
    setIsProToggleOn(state: SettingState, { payload }: PayloadAction<boolean>) {
      state.isProToggleOn = payload;
    },
    setFilterDrawerSettings(
      state: SettingState,
      { payload }: PayloadAction<FilterDrawerSettings>
    ) {
      state.filterDrawer = payload;
    },
    setSearchMode(state: SettingState, { payload }: PayloadAction<SearchMode>) {
      state.searchMode = payload;
    },
  },
});

export const {
  set1024WideScreen,
  set898WideScreen,
  set640WideScreen,
  setAskPaperDrawerSettings,
  setFilterDrawerSettings,
  setIsMobile,
  setIsProToggleOn,
  toogleSidebarOpen,
  setSidebarOpen,
  setSearchMode,
} = settingSlice.actions;
export default settingSlice.reducer;
